<template>
  <div>
    <b-card title="Seo Bilgileri">
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <b-form-group
            label="Seo Başlığı"
            label-for="seo_title"
          >
            <b-form-textarea
              id="seo_title"
              v-model="dataItem.seo_title"
              placeholder="Seo Başlığı"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <b-form-group
            label="Seo Açıklaması"
            label-for="seo_description"
          >
            <b-form-textarea
              id="seo_description"
              v-model="dataItem.seo_description"
              placeholder="Seo Açıklaması"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <b-form-group
            label="Seo Anahtar Kelimeleri"
            label-for="seo_keywords"
          >
            <b-form-textarea
              id="seo_description"
              v-model="dataItem.seo_keywords"
              placeholder="Seo Anahtar Kelimeleri"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'SeoComponent',
  components: {
    BFormTextarea,
    BFormGroup,
    BRow,
    BCol,
    BCard,
  },
  props: {
    dataStore: {
      type: String,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters[this.dataStore]
    },
  },
}
</script>
